import { render, staticRenderFns } from "./ZNSGateway.vue?vue&type=template&id=18c1187d"
import script from "./ZNSGateway.vue?vue&type=script&lang=js"
export * from "./ZNSGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports